module.exports = __webpack_public_path__ + "static/media/swagger-logo.6fb52a3b.png";